(section_name => {
    // Load required web fonts (Epilogue for headings, Nunito for body) once.
    if (!document.getElementById('acc08-fonts')) {
        var l = document.createElement('link');
        l.id = 'acc08-fonts';
        l.rel = 'stylesheet';
        l.href = 'https://fonts.googleapis.com/css2?family=Epilogue:wght@400;500;600;700;800&family=Nunito:wght@400;500;600;700;800&display=swap';
        document.head.appendChild(l);
    }
    // The image slider (Swiper) is initialised inline in the section markup.
})("acc_cb_lp_08_01");  